var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: [
        _vm.bemBlock,
        "minicart",
        {
          "change-1": _vm.willChange,
          "change-2": !_vm.willChange
        }
      ],
      attrs: {
        href: _vm.url,
        title: _vm.$msg("header.cart", "header"),
        "aria-label": _vm.$msg("header.cart", "header")
      }
    },
    [
      _c("span", { staticClass: "number old" }, [
        _vm._v(_vm._s(_vm.previousQuantity))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "number new" }, [_vm._v(_vm._s(_vm.quantity))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }